/*******************************************************************************************
   _____            __              ____   ____                         .__               
  /  _  \   _______/  |________  ___\   \ /   /____   ____  __ __  _____|__|____    ____  
 /  /_\  \ /  ___/\   __\_  __ \/  _ \   Y   // __ \ /    \|  |  \/  ___/  \__  \  /    \ 
/    |    \\___ \  |  |  |  | \(  <_> )     /\  ___/|   |  \  |  /\___ \|  |/ __ \|   |  \
\____|__  /____  > |__|  |__|   \____/ \___/  \___  >___|  /____//____  >__(____  /___|  /
        \/     \/                                 \/     \/           \/        \/     \/ 
********************************************************************************************
isDayTime Hook
********************************************************************************************

// TODO Dynamically calculate sunrise/sunset times from timezone or geolocation

Author:     Nicholas Hamilton, PhD
Email:      nicholasehamilton@gmail.com
Date:       13th June 2021

*******************************************************************************************/

import React                        from 'react';
import {isNil}                      from 'lodash';
import moment                       from 'moment';

const MIN_PERIOD = 1000;

const setIntervalAndExecute = (fn, t) => {
    fn();                       // Run Immediately
    return setInterval(fn, t);  // Allways start the interval
}

const calcIsDayTime = () => {
    const 
        now         = moment(),
        sunrise     = moment('7:00am','h:mma'),
        sunset      = moment('5:00pm','h:mma');
    return Boolean( now.isAfter(sunrise) && now.isBefore(sunset) );
}

export const useDayTime = ({
    period = 30000
} = {}) => {

    const [isDayTime, setIsDayTime]     = React.useState(calcIsDayTime());

    // React.useEffect(light,[]);
    const intervalRef = React.useRef(null);
    React.useEffect(() => {

        clearInterval(intervalRef.current);
            
        // Function to check whether day change
        const checkDayChange = () => setIsDayTime( calcIsDayTime() );

        // Determine the period from the 
        const delay = Math.max(
            Number.isFinite(period) 
                ? period 
                : -Number.MAX_SAFE_INTEGER, 
            MIN_PERIOD
        );

        // Check on interval
        intervalRef.current = setIntervalAndExecute(checkDayChange, delay);

        // Destroy interval
        return () => {
            clearInterval(intervalRef.current);
        }

    },[period]);

    return {
        isDayTime,
        isNightTime : isNil(isDayTime) ? undefined : !isDayTime
    }
}

export default useDayTime;